// Central config for Tyvena's designated Privacy / HIPAA compliance officer.
// Edit this ONE file to change the officer's identity everywhere it appears
// (Privacy Policy page, HIPAA Notice page, and anywhere else that references them).
//
// Update all four fields together for consistency, then redeploy.
export const COMPLIANCE_OFFICER = {
  name: "Kristie Poulton",
  title: "Tyvena Privacy Officer",
  email: "info@tyvena.org",
  location: "Fort Mill, South Carolina, USA",
};
